import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      d: "M7.121 13.9 5.423 6.26h14.043L16.92 13.9z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      d: "M5.76 6.72 3.84 3.84H.96M14.4 13.92H8.64a1.92 1.92 0 1 0 0 3.84h9.6"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "8.64",
      cy: "20.16",
      r: ".5",
      stroke: "currentColor",
      "stroke-width": ".92"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "16.32",
      cy: "20.16",
      r: ".5",
      stroke: "currentColor",
      "stroke-width": ".92"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "cart"}) } }